/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Threshold_CurrentInputs */

const he_notifications_threshold_current = /** @type {(inputs: Notifications_Threshold_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחיר נוכחי`)
};

const en_notifications_threshold_current = /** @type {(inputs: Notifications_Threshold_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current price`)
};

/**
* | output |
* | --- |
* | "Current price" |
*
* @param {Notifications_Threshold_CurrentInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_threshold_current = /** @type {((inputs?: Notifications_Threshold_CurrentInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Threshold_CurrentInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_threshold_current(inputs)
	return en_notifications_threshold_current(inputs)
});